import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IRedux } from 'store/ducks'
import Creators from 'store/ducks/authenticate'
import jwt from 'jsonwebtoken'
import { useForm } from 'react-hook-form'
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  DoneOutlined as DoneOutlinedIcon
} from '@mui/icons-material'
import { Dialog, DialogContent } from '@mui/material'

import {
  BorderLineSuccess,
  Button,
  Span,
  Input,
  Row,
  Form,
  Grid,
  PasswordRequerimentsChecklist,
  AutoCompleteSearchTerm
} from 'components'
import { useAuth, useLoading, useModal, useToggle } from 'hooks'
import {
  IRefreshToken,
  ProfileUserServices,
  UserServices,
  profileCreatedUserService
} from 'services/Supplier/Users'
import { COLORS, FONTS, SPACING, TYPOGRAPHY, VALIDATIONS } from 'utils'
import { passwordValidator } from 'utils/passwordValidator.utils'
import { PerfilUsuario, ProfileCreatedUser } from 'utils/types'
import { yup, yupResolver } from 'utils/yup'
import { useHistory } from 'react-router-dom'

interface IProfileModalProps {
  open: boolean
  handleClose: () => void
}

const MAX_PASSWORD_LENGTH = 8

const schema = yup
  .object({
    newPassword: yup.string().required('Informe nova senha.').password(),
    currentPassword: yup.string().required('Informe a senha atual por medidas de segurança').password(),
    confirmNewPassword: yup
      .string()
      .required('Informar Confirmar Senha')
      .test({
        message: 'Senhas se diferem',
        name: 'equalsTo',
        params: {},
        test: function (this: any, value: string) {
          return value == this.parent.newPassword
        }
      })
  })
  .required()

export const ProfileModal = ({ open, handleClose }: IProfileModalProps) => {
  const dispatch = useDispatch()
  const { setLoading, setMsgErro, toggleSucessShow, setMsgSucesso } =
    useLoading()
  const { showModal } = useModal()
  const { isPasswordModelValid } = passwordValidator()
  const { user, token, setUser } = useAuth()
  const { control, handleSubmit, formState, setError, watch, clearErrors } =
    useForm({
      resolver: yupResolver(schema)
    })

  const { push } = useHistory();

  const [showPassword, toggleShowPassword] = useToggle()
  const [showCurrentPassword, toogleShowCurrentPassword] = useToggle()
  const [profile, setProfile] = useState<PerfilUsuario | undefined>()
  const [profileCsn, setProfileCsn] = useState<ProfileCreatedUser[] | []>()
  const [selectedProfileCsn, setSelectedProfileCsn] = useState<
    ProfileCreatedUser | undefined
  >()

  const watchNovaSenha = watch('newPassword')
  const watchNovaSenhaConfirm = watch('confirmNewPassword')
  const watchCurrentPassword = watch('currentPassword')
  const allDatadescripted = useSelector((state: IRedux) => state.auth.data)
  const setAllData = (data: any) => dispatch(Creators.data(data))

  const getProfiles = useCallback(async () => {
    setLoading('loading')
    try {
      const response = await ProfileUserServices().get()

      const profRef = response?.data.find(
        (el) => el.idPerfilUsuario === user?.PerfilUsuarioId
      )

      setProfile(profRef)
      setLoading('idle')
    } catch (error: any) {
      setMsgErro(error?.mensagem)
      setLoading('error')
    }
  }, [user])

  const getProfilesCSN = useCallback(async () => {
    setLoading('loading')
    try {
      const response = await profileCreatedUserService()
        .getAll(user.IdUsuario)
        .then((response) => {
          const profRef = response?.data.find(
            (el) => el.perfilUsuarioId === user?.PerfilUsuarioId
          )
          setSelectedProfileCsn(profRef)

          setProfileCsn(response?.data)
        })

      setLoading('idle')
    } catch (error: any) {
      setMsgErro(error?.mensagem)
      setLoading('error')
    }
  }, [user])

  useEffect(() => {
    const tokenDescrited = jwt.decode(token)
    const newData = tokenDescrited?.Perfil
    //setAllData(newData)
    allDatadescripted.Perfil === 'Fornecedor' ? getProfiles() : getProfilesCSN()
  }, [getProfiles])

  async function onSubmitChangePassword(objEnvio: any) {
    clearErrors()

    if (
      !isPasswordModelValid(watchNovaSenha, 'newPassword', setError) ||
      !isPasswordModelValid(
        watchNovaSenhaConfirm,
        'confirmNewPassword',
        setError)
      ||
      !isPasswordModelValid(watchCurrentPassword, 'currentPassword', setError)
    ) {
      return
    }

    setLoading('loading')

    try {
      const { data } = await UserServices().changePassword({
        email: user.TxEmail,
        newPassword: objEnvio.newPassword,
        currentPassword: objEnvio.currentPassword
      })

      if (!data.sucesso) {
        setMsgErro(data.mensagem || 'Não foi possível alterar a senha')
        setLoading('error')
        return
      }

      setMsgSucesso('Senha alterada.')
      toggleSucessShow()
      setLoading('idle')
    } catch (error: any) {
      const msgErro = error?.response?.data?.mensagem || "Não foi possível alterar a senha"
      setMsgErro(msgErro)
      setLoading('error')
    }
  }

  const profileInputs = [
    {
      fields: [
        {
          label: 'CPF/Passaporte',
          placeholder: '000.000.000-00',
          value: user?.CdDocto,
          disabled: true
        },
        {
          label: 'Colaborador',
          placeholder: 'Nome Completo',
          value: user?.NmUsuario,
          disabled: true
        }
      ],
      group: 1
    },
    {
      fields: [
        {
          label: 'Contato',
          placeholder: '(00) 90000-0000',
          value: user?.NuContato,
          disabled: true
        },
        {
          label: 'E-mail',
          placeholder: 'E-mail',
          value: user?.TxEmail,
          disabled: true
        }
      ],
      group: 2
    }
  ]

  const passwordMatchIcon = () => {
    if (
      watchNovaSenhaConfirm?.length < MAX_PASSWORD_LENGTH - 1 ||
      watchNovaSenha?.length < MAX_PASSWORD_LENGTH - 1
    ) {
      return null
    }

    if (watchNovaSenha !== watchNovaSenhaConfirm) {
      return null
    }

    return <DoneOutlinedIcon cursor="default" color="success" />
  }

  const getPasswordRequerimentSatisfiedColor = (satisfied: boolean) => {
    if (watchNovaSenha?.length === 0) {
      return 'black'
    }

    if (!satisfied) {
      return COLORS.error
    }

    return COLORS.success
  }

  const handleSetProfile = async (selectProfile: ProfileCreatedUser) => {
    if (
      selectProfile &&
      selectProfile?.perfilUsuarioId !== user?.PerfilUsuarioId
    ) {
      //Refresh Token

      const refreshTkn = localStorage.getItem('csn-rtk')
      const tkn = localStorage.getItem('csn-tk')
      const refreshObj: IRefreshToken = {
        email: user.TxEmail,
        refreshToken: refreshTkn,
        token: tkn,
        role: selectProfile.role,
        perfilUsuarioId: selectProfile.perfilUsuarioId.toString()
      }

      setLoading("loading")

      //Atualização do Token
      await UserServices()
        .refreshToken(refreshObj)
        .then(async (response) => {
          if (response.status === 200) {

            const newToken = response.data.token

            if (newToken != tkn) {
              //Atualização do Perfil do Usuário
              await UserServices()
                .updateProfile(user.IdUsuario, selectProfile.perfilUsuarioId)
                .then((response) => {
                  if (response.status === 200 && response?.data?.sucesso) {
                    localStorage.setItem('csn-tk', newToken.toString())
                    setLoading('idle')
                    push({ pathname: allDatadescripted?.Perfil === 'Csn' ? '/ngt' : '/gst', state: { initialPage: true } })

                    showModal({
                      hideButtonCancel: true,
                      message: response.data.mensagem,
                      txtButtonConfirm: 'OK',
                      handleConfirm: handleConfirmPopUp,
                      type: 'success'
                    })

                    setLoading("idle")

                  } else {
                    showModal({
                      hideButtonCancel: true,
                      message: 'Ocorreu um problema ao atualizar o perfil.',
                      txtButtonConfirm: 'OK',
                      handleConfirm: handleConfirmPopUp,
                      type: 'error'
                    })
                  }
                  setLoading("idle")

                })
              setSelectedProfileCsn(selectProfile)
              const copyUser = { ...user }
              copyUser.PerfilUsuarioId = selectProfile.perfilUsuarioId
              setUser(copyUser)
            }
          }
        }).catch((error) => {
          setLoading("idle")
          showModal({
            hideButtonCancel: true,
            message: error?.message ?? 'Ocorreu um problema ao atualizar o perfil.',
            txtButtonConfirm: 'OK',
            handleConfirm: handleConfirmPopUp,
            type: 'error'
          })
        })
    }
  }
  const handleConfirmPopUp = () => {
    window.location.reload()
  }
  const disabledSaved = (novaSenha: string, novaSenhaConfirm: string, senhaAtual: string) => {
    if (
      !VALIDATIONS.minCharacters(novaSenha, 8) &&
      !VALIDATIONS.minCharacters(novaSenhaConfirm, 8) && !VALIDATIONS.minCharacters(senhaAtual, 8)
    ) {
      return true
    }
    return false
  }


  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <BorderLineSuccess colorLine={COLORS.secondary} />
        <DialogContent>
          <Form onSubmit={handleSubmit(onSubmitChangePassword)}>
            <div style={{ marginTop: '24px' }}>
              <Span
                text="Perfil"
                fontSize={TYPOGRAPHY.subtitleSize20}
                fontWeight={FONTS.bold}
              />
              {profileInputs.map(({ group, fields }) => (
                <Grid gridCols="1fr" margin="1rem 0 0 0">
                  {fields
                    .filter((x) => {
                      if (
                        (allDatadescripted?.Perfil != 'Fornecedor' &&
                          x.label == 'E-mail') ||
                        x.label == 'Colaborador'
                      ) {
                        return x
                      } else return null
                    })
                    .map((props) => (
                      <Input
                        key={props?.label}
                        width="500px"
                        marginBottom={SPACING.spacing20}
                        {...props}
                      />
                    ))}
                </Grid>
              ))}
              {allDatadescripted.Perfil === 'Fornecedor' ? (
                <Input
                  value={profile?.txDenominacao}
                  label="Perfil"
                  placeholder="Perfil de Acesso"
                  marginBottom={SPACING.spacing20}
                  disabled
                />
              ) : (
                <AutoCompleteSearchTerm
                  value={selectedProfileCsn?.nomePerfil ?? ''}
                  options={profileCsn ?? []}
                  optionLabel="nomePerfil"
                  label="Perfil de Acesso"
                  optionValue="perfilUsuarioId"
                  onChange={(_e, value: ProfileCreatedUser) =>
                    handleSetProfile(value)
                  }
                />
              )}
            </div>
            <div style={{ marginTop: SPACING.spacing15 }}>
              {allDatadescripted?.Perfil === 'Fornecedor' && (
                <>
                  <Span
                    text="Alterar Senha"
                    fontSize={TYPOGRAPHY.subtitleSize20}
                    fontWeight={FONTS.bold}
                    marginBottom={SPACING.spacing20}
                  />
                  <Grid gridCols="1fr" gridGap="1rem" margin="1rem 0 1rem 0">
                    <Input
                      label="Senha Atual"
                      control={control}
                      formValue="currentPassword"
                      errors={formState.errors}
                      onClickIcon={toogleShowCurrentPassword}
                      inputIcon={
                        showCurrentPassword ? (
                          <VisibilityOffIcon cursor="pointer" />
                        ) : (
                          <VisibilityIcon cursor="pointer" />
                        )
                      }
                      defaultValue=""
                      type={showCurrentPassword ? 'none' : 'password'}
                      placeholder='Digite a senha atual'
                    />

                    <Input
                      label="Nova Senha"
                      control={control}
                      formValue="newPassword"
                      errors={formState.errors}
                      onClickIcon={toggleShowPassword}
                      inputIcon={
                        showPassword ? (
                          <VisibilityOffIcon cursor="pointer" />
                        ) : (
                          <VisibilityIcon cursor="pointer" />
                        )
                      }
                      defaultValue=""
                      type={showPassword ? 'none' : 'password'}
                    />

                    <Input
                      label="Confirmar Senha"
                      control={control}
                      formValue="confirmNewPassword"
                      defaultValue=""
                      type="password"
                      inputIcon={passwordMatchIcon()}
                      errors={formState.errors}
                    />
                  </Grid>

                  <Grid gridCols="1fr" margin="1rem">
                    <PasswordRequerimentsChecklist password={watchNovaSenha}>
                      {(requeriments) =>
                        requeriments.map((requeriment) => (
                          <Row alignItems="center" justifyContent="flex-start">
                            <Span
                              key={requeriment.id}
                              text={requeriment.description}
                              fontSize={TYPOGRAPHY.bodySize13}
                              marginRight={SPACING.spacing30}
                              color={getPasswordRequerimentSatisfiedColor(
                                requeriment.satisfied
                              )}
                            />
                          </Row>
                        ))
                      }
                    </PasswordRequerimentsChecklist>
                  </Grid>
                </>
              )}
            </div>
            <Row
              justifyContent="flex-end"
              marginBottom={SPACING.spacing20}
              marginTop={SPACING.spacing10}
            >
              {allDatadescripted?.Perfil === 'Fornecedor' && (
                <Button
                  text="Fechar"
                  variantButton="outlined"
                  marginRight={SPACING.spacing20}
                  onClick={handleClose}
                />
              )}
              {allDatadescripted?.Perfil === 'Fornecedor' ? (
                <Button
                  text="Salvar"
                  type="submit"
                  disabled={disabledSaved(
                    watchNovaSenha,
                    watchNovaSenhaConfirm,
                    watchCurrentPassword
                  )}
                />
              ) : (
                <Button text="Fechar" onClick={handleClose} />
              )}
            </Row>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  )
}